<template>
	<main id="main" class="main">
		<section class="lists">
			<div class="inner">
				<!-- 電腦版tab -->
				<div id="tablinks" class="tabs tablinks">
					<button
						v-for="(tab, index) in tabList"
						:key="`tab-${index}`"
						:class="{'active': tabActive === index}"
						class="tablink Sheet1_Click"
						@click="clickTablink(index)"
					>
						{{ tab }}
					</button>
				</div>
				<div class="cats tabcontent">
				<a
					v-for="(article, index) in articleData"
					:key="`${tabList[tabActive]}-${index}`"
					class="item"
					:href="article.link"
					target="_blank"
					rel="noreferrer noopener"
					@click="sendAnalytic('Blogger', 'Click', `blogger_${article.detail.author.name}`)"
				>
					<div class="img">
					<img :src="article.image" />
					</div>
					<div class="description">
					<p>{{ article.title }}</p>
					</div>
				</a>
				</div>
			</div>
			<div
				class="hamburger"
				@click="sideMenuActive = !sideMenuActive"
			>
			</div>
			<!-- 手機版menu -->
			<div
				class="side_menu"
				:class="{ 'active': sideMenuActive }"
			>
				<div class="top">
					<div
						class="close"
						@click="sideMenuActive = !sideMenuActive"
					>
						<img src="@/assets/close.svg" />
					</div>
				</div>
				<div
					v-for="(tab, index) in tabList"
					:key="`tab-mb-${index}`"
					:class="{'active': tabActive === index}"
					class="tablink Sheet1_Click"
					@click="clickTablink(index)"
				>
					{{ tab }}
				</div>
			</div>
		</section>
		<!-- 看更多文章 -->
		<section class="more-article">
			<button class="btn-more js-more-article Content_more_click"
					v-show="pageOption.page < pageOption.pageTotal"
					@click="getMoreArticleData()">看更多文章</button>
		</section>
	</main>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import sendAnalytic from '@/common/sendAnalytic';
import { ARTICLE_TABS, ARTICLE_DATA_BY_TAB, PAGE_SIZE } from '@/data/articles';

const tabList = ARTICLE_TABS;
const tabActive = ref(0);
const sideMenuActive = ref(false);

const articleData = ref([]);

/** 頁數控制
 * @param {number} page 當前頁數
 * @param {number} pageSize 一頁幾筆資料
 */
const pageOption = reactive({
	page: 1,
	pageTotal: 1
})

const getTabArticles = () => ARTICLE_DATA_BY_TAB[tabList[tabActive.value]] || [];

const syncArticleData = () => {
	const currentArticles = getTabArticles();
	const pageTotal = Math.ceil(currentArticles.length / PAGE_SIZE) || 1;

	pageOption.pageTotal = pageTotal;
	articleData.value = currentArticles.slice(0, pageOption.page * PAGE_SIZE);
};

const clickTablink = id => {
	tabActive.value = id;
	sideMenuActive.value = false;
	getArticleData();
	sendAnalytic('Sheet', 'Click', `Sheet${id+1}_Click`);
}

/** 取得文章
 * @param {number} page 當前頁數
 */
const getArticleData = (page = 1) => {
	pageOption.page = page;

	syncArticleData();
};

const getMoreArticleData = () => {
	if (pageOption.page >= pageOption.pageTotal) {
		return;
	}

	pageOption.page++;
	syncArticleData();
	sendAnalytic('Content', 'Click', 'Content_more_click');
}

onMounted(() => {
	getArticleData();
});

</script>
